<template>
  <div>
    <WsDialog
      v-model="dialog"
      ref="WsDialog"
      @close="$_handleDialogClose()"
      :title="title"
    >
      <template v-slot:content>
        <WsCRUD
          :modelName="modelName"
          :label="label"
          :fields="fields"
          :sortBy="sortBy"
          :showFields="showFields"
          :pageMode="true"
          :showExpand="false"
          :rowClickRead="false"
          :isShowBtn="false"
          :filterSelects="filterSelects"
          :liveSearching="true"
          :isMultiSelect="true"
          :showTitlebar="false"
          :rowClickEmit="true"
          @input="$_onSelected($event)"
        >
        </WsCRUD>
        <!-- <WsMultiSelectDialog
      ref="multiSelectDialog"
      title="確定要刪除嗎？"
      description="刪除後資料將無法回覆"
      @submit="$_onDeleteMultiSubmit($event)"
    /> -->
      </template>
      <template v-slot:rightActions>
        <WsBtn
          @click="$_onCancel()"
          minWidth="100px"
          color="textSecondary"
          outlined
        >取消</WsBtn>
        <WsBtn
          @click="$_onSubmit()"
          minWidth="100px"
          :loading="submitLoading"
          color="primary"
        >確定</WsBtn>
      </template>
    </WsDialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    createData: {},
    submitLoading: false,
    dialog: false,
    sortBy: "sequence",
  }),
  methods: {
    $_getErrorMessage(fieldKey) {
      if (this.errorMessages) {
        if (this.errorMessages[fieldKey]) {
          return this.errorMessages[fieldKey];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    $_handleDialogClose() {
      window.removeEventListener("keydown", this.$_keydownHandler);
    },
    $_keydownHandler(event) {
      if (event.metaKey && event.key == "Enter") {
        this.$_onSubmit();
      }
    },
    stopLoading() {
      this.submitLoading = false;
    },
    startLoading() {
      this.submitLoading = true;
    },
    async $_onSubmit() {
      this.$emit("create-submit", this.createData);
    },
    $_onCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      window.removeEventListener("keydown", this.$_keydownHandler);
    },
    open() {
      // this.$_CMS_updateDataSetFromFields(this, this.createData, this.fields);
      this.dialog = true;
      window.addEventListener("keydown", this.$_keydownHandler);
    },
    $_onSelected($event) {
      this.createData = $event;
    },
  },
  props: {
    errorMessages: {
      type: Object,
      default: null,
    },
    modelName: String,
    label: {
      type: String,
      default: null,
    },
    fields: Object,
    title: {
      type: String,
    },
    filterSelects: {
      type: Array,
      default: null,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    showFields: {
      type: Array,
    },
  },
};
</script>